"use strict";
(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[208],{

/***/ 9150:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var scripts_vue_main__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3200);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9346);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var vue_js_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(412);
/* harmony import */ var vue_js_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue_js_modal__WEBPACK_IMPORTED_MODULE_1__);




vue__WEBPACK_IMPORTED_MODULE_2___default().use((vue_js_modal__WEBPACK_IMPORTED_MODULE_1___default()));
window.PSTheme.Vue.Reviewers = new (vue__WEBPACK_IMPORTED_MODULE_2___default())({
  name: 'ReviewersWrapper',
  components: {
    'reviewers': (__webpack_require__(6033)/* ["default"] */ .Z)
  }
}).$mount('.reviewers');

/***/ }),

/***/ 9508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ mq_breakpoints; },
/* harmony export */   "ku": function() { return /* binding */ px_breakpoints; }
/* harmony export */ });
/* unused harmony export px_queries */
// EMs
let mq_breakpoints = {
  '--mobile-down': '(max-width: 25.99em)',
  '--mobile-up': '(min-width: 26em)',
  '--phablet-down': '(min-width: 32.49em)',
  '--phablet-up': '(min-width: 32.5em)',
  '--tablet-down': '(max-width: 39.99em)',
  '--tablet-up': '(min-width: 40em)',
  '--tablet-lg-down': '(min-width: 63.99em)',
  '--tablet-lg-up': '(min-width: 64em)',
  '--laptop-down': '(max-width: 71.99em)',
  '--laptop-up': '(min-width: 72em)',
  '--desktop-down': '(max-width: 99.99em)',
  '--desktop-up': '(min-width: 100em)',
  '--ultrawide': '(min-width: 125em)'
}; // Pixels

let px_breakpoints = {
  '--mobile-up': 416,
  '--phablet-up': 520,
  '--tablet-up': 640,
  '--tablet-lg-up': 1024,
  '--laptop-up': 1152,
  '--desktop-up': 1600,
  '--ultrawide': 2000
};
let px_queries = {
  '--mobile-up': '(min-width: 416px)',
  '--phablet-up': '(min-width: 520px)',
  '--tablet-up': '(min-width: 640px)',
  '--tablet-lg-up': '(min-width: 1024px)',
  '--laptop-up': '(min-width: 1152px)',
  '--desktop-up': '(min-width: 1600px)',
  '--ultrawide': '(min-width: 2000px)'
};


/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./src/scripts/vue/store/global.js

const store = vue_min_default().observable({
  menuActive: false,
  searchActive: false,
  notificationsActive: false,
  closeAnnouncement: false,
  customerCountry: 'NZ'
});
const actions = {
  openMenu() {
    store.menuActive = true;
  },

  toggleMenu() {
    if (store.menuActive) {
      this.closeAll();
    } else {
      this.closeAll();
      store.menuActive = true;
    }
  },

  toggleSearch() {
    store.searchActive = !store.searchActive;
  },

  toggleNotifications() {
    store.notificationsActive = !store.notificationsActive;
  },

  closeAll() {
    store.menuActive = false;
    store.searchActive = false;
    store.notificationsActive = false;
    window.PSTheme.Vue.Header.secondMenuIdx = null;
    window.PSTheme.Vue.Header.thirdMenuIdx = null;
  }

};
(vue_min_default()).prototype.$store = store;
(vue_min_default()).prototype.$actions = actions;
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
// EXTERNAL MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.mjs
var vue_composition_api = __webpack_require__(5706);
// EXTERNAL MODULE: ./node_modules/vue-screen/dist/vue-screen.esm.js
var vue_screen_esm = __webpack_require__(6768);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/currency.js
var currency = __webpack_require__(1186);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-images/images.js
var theme_images_images = __webpack_require__(3253);
;// CONCATENATED MODULE: ./src/scripts/vue/main.js







/* config */

(vue_min_default()).config.devtools = true;
(vue_min_default()).config.productionTip = false;
(vue_min_default()).config.silent = true;
/* extensions */

(vue_min_default()).prototype.$language = globalThis.PSTheme.Language;
(vue_min_default()).prototype.$settings = globalThis.PSTheme.Settings;
(vue_min_default()).prototype.$customer = globalThis.PSTheme.Customer;

(vue_min_default()).prototype.$image = (src, size = '750x') => theme_images_images/* getSizedImageUrl */.M0(src, size);

(vue_min_default()).prototype.$preloadImages = (imgArray, size = '750x') => theme_images_images/* preload */.MA(imgArray, size);

(vue_min_default()).prototype.$money = amount => (0,currency/* formatMoney */.l)(amount, '${{amount}}');

(vue_min_default()).prototype.$isEmpty = obj => {
  if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true;
};
/* plugins */


vue_min_default().use(vue_composition_api/* default */.ZP);
vue_min_default().use(vue_screen_esm/* default */.Z, {
  mobile_up: breakpoints/* px_breakpoints.--mobile-up */.ku["--mobile-up"],
  tablet_up: breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"],
  tablet_lg_up: breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"],
  laptop_up: breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"],
  desktop_up: breakpoints/* px_breakpoints.--desktop-up */.ku["--desktop-up"]
});

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Loading; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[ 'site-loading', { 'activated': _vm.props.activated }],staticStyle:{"z-index":"100"}},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"circle one"}),_vm._v(" "),_c('div',{staticClass:"circle two"})])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Loadingvue_type_script_lang_js_ = ({
  name: 'Loading',
  props: ['activated']
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Loadingvue_type_script_lang_js_ = (Loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_Loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var Loading = (component.exports);

/***/ }),

/***/ 3133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VImg; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=template&id=4a5ed573&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vimg",class:_vm.customClass,attrs:{"src":_vm.fixedSize ? _vm.$image(_vm.media.src, _vm.fixedSize) : _vm.$image(_vm.media.src),"srcset":_vm.fixedSize ? '' : _vm.srcset,"data-sizes":"auto","alt":_vm.media.alt || _vm.$attrs.alt || 'Image',"loading":_vm.loading_method || 'lazy'}})}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VImgvue_type_script_lang_js_ = ({
  name: 'VImg',
  props: ['media', 'fixedSize', 'customClass', 'loading_method'],
  computed: {
    srcset() {
      if (this.fixedSize) return null;
      const {
        src,
        width
      } = this.media;
      const srcset = `${this.$image(src, '200x')} 100w'
      ${width >= 200 ? `, ${this.$image(src, '400x')} 200w` : ''}
      ${width >= 400 ? `, ${this.$image(src, '800x')} 400w` : ''}
      ${width >= 600 ? `, ${this.$image(src, '1200x')} 600w` : ''}
      ${width >= 800 ? `, ${this.$image(src, '1600x')} 800w` : ''}
      ${width >= 1000 ? `, ${this.$image(src, '2000x')} 1000w` : ''}
      ${width >= 1500 ? `, ${this.$image(src, '3000x')} 1500w` : ''}
      ${width >= 2000 ? `, ${this.$image(src, '4000x')} 2000w` : ''}`;
      return srcset;
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VImgvue_type_script_lang_js_ = (VImgvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_VImgvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VImg = (component.exports);

/***/ }),

/***/ 6033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Reviewers; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/templates/Reviewers.vue?vue&type=template&id=0ce2e3c8&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.section && _vm.section.blocks)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"reviewers__blocks--wrapper"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"reviewers__blocks"},_vm._l((_vm.reviewers),function(reviewer,idx){return _c('div',{key:reviewer.id,staticClass:"reviewers-block",class:{ 'active': idx == _vm.activeReviewer },on:{"click":function($event){return _vm.open(idx)}}},[_c('h5',{staticClass:"reviewers-block__label"},[_vm._v(_vm._s(reviewer.name))])])}),0)]),_vm._v(" "),_c('modal',{attrs:{"name":"reviewer","width":"90%","height":"85%","maxWidth":850,"maxHeight":500,"adaptive":true},on:{"before-close":function($event){_vm.activeReviewer = null}}},[(_vm.reviewers[_vm.activeReviewer])?_c('div',{staticClass:"modal-person"},[_c('button',{staticClass:"vm--close",on:{"click":function($event){return _vm.close()}}}),_vm._v(" "),_c('div',{staticClass:"modal-person__left"},[_c('i',{staticClass:"signature"},[_vm._v("Please meet")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.reviewers[_vm.activeReviewer].name))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.reviewers[_vm.activeReviewer].content)}})]),_vm._v(" "),(_vm.reviewers[_vm.activeReviewer].image.src)?_c('div',{staticClass:"modal-person__right"},[_c('VImg',{attrs:{"media":_vm.reviewers[_vm.activeReviewer].image}}),_vm._v(" "),(_vm.reviewers[_vm.activeReviewer].fb_link)?_c('p',[_c('small',[_c('a',{staticClass:"btn--small",attrs:{"href":_vm.reviewers[_vm.activeReviewer].fb_link,"target":"_blank","title":((_vm.reviewers[_vm.activeReviewer].name) + "'s facebook link"),"aria-label":((_vm.reviewers[_vm.activeReviewer].name) + "'s facebook link")}},[_vm._v("\n              "+_vm._s(_vm.reviewers[_vm.activeReviewer].name)+"'s facebook link\n            ")])])]):_vm._e()],1):_vm._e()]):_vm._e()])],1):_c('Loading',{attrs:{"activated":true}})}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reviewers__header"},[_c('h1',{staticClass:"alternative-page"},[_c('i',{staticClass:"signature"},[_vm._v("Our")]),_vm._v(" "),_c('span',{staticClass:"outline",staticStyle:{"--text":"'Reviewers'"}},[_vm._v("Reviewers")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"reviewers__blocks-header"},[_c('p',[_vm._v("Please, click on the cards to learn more.")])])}]


;// CONCATENATED MODULE: ./src/scripts/vue/templates/Reviewers.vue?vue&type=template&id=0ce2e3c8&

// EXTERNAL MODULE: ./src/scripts/vue/components/VImg.vue + 3 modules
var VImg = __webpack_require__(3133);
// EXTERNAL MODULE: ./src/scripts/vue/components/Loading.vue + 4 modules
var Loading = __webpack_require__(9918);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/templates/Reviewers.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var Reviewersvue_type_script_lang_js_ = ({
  name: 'Reviewers',
  components: {
    VImg: VImg/* default */.Z,
    Loading: Loading/* default */.Z
  },
  props: ['page_content'],
  computed: {
    reviewers() {
      return this.section.blocks;
    }

  },

  data() {
    return {
      section: null,
      activeReviewer: null
    };
  },

  mounted() {
    this.loadSection();
  },

  methods: {
    loadSection() {
      fetch(`/collections/all?view=reviewers`).then(res => res.json()).then(data => {
        if (data.length) {
          this.section = JSON.parse(data);
        }
      });
    },

    open(idx) {
      this.activeReviewer = idx;
      this.$modal.show('reviewer');
    },

    close() {
      this.$modal.hide('reviewer');
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/templates/Reviewers.vue?vue&type=script&lang=js&
 /* harmony default export */ var templates_Reviewersvue_type_script_lang_js_ = (Reviewersvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/templates/Reviewers.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  templates_Reviewersvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Reviewers = (component.exports);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346,383,412], function() { return __webpack_exec__(9150); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);